import * as React from "react";

import { Button, Form, Modal } from "semantic-ui-react";

import { useForm, FormProvider } from "react-hook-form";

import { zodResolver } from "@hookform/resolvers/zod";
import { useDispatch } from "@teamprevent/admin-redux";

import { SemanticReactHookFormsInput } from "@teamprevent/common/forms/SemanticReactHookFormsInput";
import { SemanticReactHookFormsDropdown } from "@teamprevent/common/forms/SemanticReactHookFormsDropdown";

import { CustomMedicalTypeFormModel, customMedicalTypeSchema } from "../schema";
import { createMedicalType } from "../actions";
import { ConsultationSectionOptions, QuestionnaireSectionOptions } from "../models";

interface OwnProps {
    open: boolean;
    closeModal: () => void;
}

export const CreateModal: React.FunctionComponent<OwnProps> = (props: OwnProps) => {
    const { open, closeModal } = props;

    const { handleSubmit, reset, register, control, ...methods } = useForm<CustomMedicalTypeFormModel>({
        resolver: zodResolver(customMedicalTypeSchema),
        defaultValues: { name: "", questionnaireSectionIds: [], consultationSectionIds: [] },
        shouldFocusError: true,
        mode: "onBlur"
    });

    const close = React.useCallback(() => {
        reset();
        closeModal();
    }, [closeModal, reset]);

    const dispatch = useDispatch();
    const save = React.useCallback(async (model: CustomMedicalTypeFormModel) => {
        await dispatch(createMedicalType(model));
        close();
    }, [close, dispatch]);

    return (
        <Modal as={Form} size="small" open={open} onClose={close} onSubmit={handleSubmit(save)} closeOnDimmerClick={false}>
            <FormProvider handleSubmit={handleSubmit} reset={reset} register={register} control={control} {...methods}>
                <Modal.Header>Create Medical</Modal.Header>
                <Modal.Content>
                    <SemanticReactHookFormsInput
                        label="Medical Name"
                        control={control}
                        name="name"
                    />
                    <SemanticReactHookFormsDropdown
                        label="Questionnaire Sections"
                        control={control}
                        name="questionnaireSectionIds"
                        options={QuestionnaireSectionOptions}
                        search
                        multiple
                    />
                    <SemanticReactHookFormsDropdown
                        label="Consultation Sections"
                        control={control}
                        name="consultationSectionIds"
                        options={ConsultationSectionOptions}
                        search
                        multiple
                    />
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={close}>Cancel</Button>
                    <Button content="Save" type="submit" />
                </Modal.Actions>
            </FormProvider>
        </Modal>
    );
};
